import { TranslateOptions } from '../types/animations';
import { DomElementState } from '../types/object';
import { gsap } from 'gsap';
import { TimelineExt, TimelineWithPosition } from '../utils/combine';

export function translateDomProperty(o: HTMLElement | string, options: TranslateOptions<DomElementState>): gsap.core.Timeline;
export function translateDomProperty(o: HTMLElement | string, options: TranslateOptions<DomElementState>, position: gsap.Position): TimelineWithPosition;
export function translateDomProperty(o: HTMLElement | string, options: TranslateOptions<DomElementState>, position?: gsap.Position): TimelineExt {
    const { tl: existingTl, from, to, reset, vars, timelineVars } = options || { };

    if (reset && from) {
        gsap.set(o, from);
    }

    const tl = existingTl || gsap.timeline(timelineVars);

    if (to) {
        if (from) {
            tl.fromTo(
                o,
                from,
                { ...to, ...vars },
                0,
            );
        } else {
            tl.to(
                o,
                { ...to, ...vars },
                0,
            );
        }
    }

    if (position !== undefined) {
        return { tl, position };
    }

    return tl;
}
